module.exports = __webpack_public_path__ + "img/fm-f-Path 52 Copy@3x.39cfbcdf.png";